// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Payloads__container-fbbf80 {
  margin: 0 auto;
  margin-top: 40px;
}

.Payloads__info-d7f53c {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 16px;
}

.Payloads__title-bc289a {
  font: var(--font-title-5);
  letter-spacing: var(--font-spacing-title-5);
  color: var(--base-110);
}

.Payloads__date-a0009f {
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
  color: var(--base-80);
}

.Payloads__viewsIcon-bc086b {
  width: 16px;
  height: 16px;
  fill: var(--base-70);
  margin-inline-end: 5px;
  margin-top: -1px;
}

.Payloads__content-f74d56 {
  padding-bottom: 40px;
}

.Payloads__payload-cdac77 {
  margin-top: 24px;
}

.Payloads__AudioMessage-c03e81 + .Payloads__AudioMessage-c03e81 {
  margin-top: 8px;
}

.Payloads__File-f45e65 + .Payloads__Contact-f3c228 {
  margin-top: 0;
}

.Payloads__Contact-f3c228 + .Payloads__Contact-f3c228 {
  margin-top: 0;
}

.Payloads__Contact-f3c228 + .Payloads__File-f45e65 {
  margin-top: 0;
}

.Payloads__File-f45e65 + .Payloads__File-f45e65 {
  margin-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/ArticlePreview/Payloads/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,yBAAA;EACA,2CAAA;EACA,sBAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,qBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;AACF","sourcesContent":[".container {\n  margin: 0 auto;\n  margin-top: 40px;\n}\n\n.info {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.title {\n  font: var(--font-title-5);\n  letter-spacing: var(--font-spacing-title-5);\n  color: var(--base-110);\n}\n\n.date {\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n  color: var(--base-80);\n}\n\n.viewsIcon {\n  width: 16px;\n  height: 16px;\n  fill: var(--base-70);\n  margin-inline-end: 5px;\n  margin-top: -1px;\n}\n\n.content {\n  padding-bottom: 40px;\n}\n\n.payload {\n  margin-top: 24px;\n}\n\n.AudioMessage + .AudioMessage {\n  margin-top: 8px;\n}\n\n.File + .Contact {\n  margin-top: 0;\n}\n\n.Contact + .Contact {\n  margin-top: 0;\n}\n\n.Contact + .File {\n  margin-top: 0;\n}\n\n.File + .File {\n  margin-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Payloads__container-fbbf80`,
	"info": `Payloads__info-d7f53c`,
	"title": `Payloads__title-bc289a`,
	"date": `Payloads__date-a0009f`,
	"viewsIcon": `Payloads__viewsIcon-bc086b`,
	"content": `Payloads__content-f74d56`,
	"payload": `Payloads__payload-cdac77`,
	"AudioMessage": `Payloads__AudioMessage-c03e81`,
	"audioMessage": `Payloads__AudioMessage-c03e81`,
	"File": `Payloads__File-f45e65`,
	"file": `Payloads__File-f45e65`,
	"Contact": `Payloads__Contact-f3c228`,
	"contact": `Payloads__Contact-f3c228`
};
module.exports = ___CSS_LOADER_EXPORT___;
